import React, { useState, useCallback } from "react";
import { OrgIdContext, ClientTypes, CustomerType } from "./orgId_context";

const OrgIdContextProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSessionChecked, setIsSessionChecked] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [mainOrgId, setMainOrgId] = useState("");
  const [mainOrgUsername, setMainOrgUsername] = useState("");
  const [clientOrgId, setClientOrgId] = useState("");
  const [connectionKey, setConnectionKey] = useState("");
  const [connectionKeyMode, setConnectionKeyMode] = useState();
  const [modeREI, setModeREI] = useState();
  const [integrationDevice, setIntegrationDevice] = useState("");
  const [defaultDevice, setDefaultDevice] = useState();
  const [defaultDeviceMode, setDefaultDeviceMode] = useState();
  const [isMaintainer, setIsMaintainer] = useState(null);
  const [isTrustee, setIsTrustee] = useState(null);
  const [isSuperUser, setIsSuperUser] = useState(null);
  const [mainOrgCountry, setMainOrgCountry] = useState(null);
  const [aboutOrgId, setAboutOrgId] = useState();
  const [domain, setDomain] = useState();
// const [mainOrgTransfId, setMainOrgTransfId] = useState(null);

  const [isTransformer, setIsTransformer] = useState(null);
  const [isIntegrator, setIsIntegrator] = useState(null);
  const [isBuilder, setIsBuilder] = useState(null);
  const [clientType, setClientType] = useState(null);
  const [ISVCustomer,setISVCustomer] = useState(null);
  const [AccCustomer, setAccCustomer] = useState(null);
  const [customerRelation, setCustomerRelation] = useState(null);
  const [roles, setRoles] = useState([]);
  const [sessionInfo, setSessionInfo] = useState();

  const [integrationNotFinished, setIntegrationNotFinished] = useState(null);

  const setIntegrationNotFinishedHandler = useCallback((bool) => {
    setIntegrationNotFinished(bool);
  }, []);

  const changeRoles = useCallback((role, removeOrAdd) =>{
    if(removeOrAdd){
      if(roles.indexOf(role) >= 0)
        return;
      setRoles([...roles, role]);
    }else{
      setRoles((prev) => prev.filter(e => e !==role))
    }
  }, [roles]);

  const setIsTransformerHandler = useCallback((bool) => {
    setIsTransformer(bool);
    changeRoles("transformer", bool);
  }, [changeRoles]);
  const setIsIntegratorHandler = useCallback((bool) => {
    setIsIntegrator(bool)
    changeRoles("integrator", bool);
  }, [changeRoles]);
  const setIsBuilderHandler = useCallback((bool) => {
    setIsBuilder(bool)
    changeRoles("builder", bool);
  }, [changeRoles]);
  const setClientTypeHandler = useCallback((string) => setClientType(string), []);
  const setISVCustomerHandler = useCallback((string) => {
    setISVCustomer(string);
    string ? changeRoles("ISVCustomer", true) : changeRoles("ISVCustomer", false);
  }, [changeRoles]);
  const setAccCustomerHandler = useCallback((string) => {
    setAccCustomer(string);
    string ? changeRoles("AccCustomer", true) : changeRoles("AccCustomer", false);
  }, [changeRoles]);
  const setCustomerRelationHandler = useCallback((string) => setCustomerRelation(string), []);
  const setSessionInfoHandler = useCallback((obj) => setSessionInfo(obj), []);
  const setAboutOrgIdHandler = useCallback((string) => {setAboutOrgId(string);}, []);
  const setDefaultDeviceHandler  = useCallback((string) => {setDefaultDevice(string);}, []);
  const setDefaultDeviceModeHandler  = useCallback((string) => {setDefaultDeviceMode(string);}, []);
  const setDomainHandler  = useCallback((string) => {setDomain(string);}, []);
  const setModeREIHandler  = useCallback((bool) => {setModeREI(bool);}, []);
  

  const getRoles = useCallback(() => {
    let ret = [];
    if(isTransformer)
    ret.push("transformer");
    if(isIntegrator)
    ret.push("integrator");
    if(isBuilder)
    ret.push("builder");
    if(ISVCustomer)
    ret.push(CustomerType.ISVCustomer);
    if(AccCustomer)
    ret.push(CustomerType.AccCustomer);
    //if(clientType)
    ret.push(clientType);
    if(isTrustee)
    ret.push("trustee")
    if(isSuperUser)
    ret.push("superuser")
    return ret;
  }, [isTransformer, isIntegrator, isBuilder, ISVCustomer, AccCustomer, clientType, isTrustee, isSuperUser]);

  const setMainOrgHandler = useCallback((id, name) => {
    setMainOrgId(id);
    setMainOrgUsername(name);
    // console.log("updated main org");
  }, []);


  const setClientOrgHandler = useCallback((id) => setClientOrgId(id), []);

  const setConnKeyHandler = (key) => setConnectionKey(key);
  const setConnectionKeyModeHandler = (mode) => setConnectionKeyMode(mode);
  const setIntegrationDeviceHandler = (key) => setIntegrationDevice(key);

  const onIsMaintainerHandler = useCallback((containsMaintainer) => {
    setIsMaintainer(containsMaintainer);
  }, []);
  const setIsTrusteeHandler = useCallback((containsTrustee) => {
    setIsTrustee(containsTrustee);
  }, []);
  const setIsSuperUserHandler = useCallback((containsSuperUser) => {
    setIsSuperUser(containsSuperUser);
  }, []);

  const setMainCountryHandler = useCallback((country) => {
    setMainOrgCountry(country);
  }, []);

  // const onMainOrgTransfIdHandler = useCallback(
  //   (id) => setMainOrgTransfId(id),
  //   []
  // );

  const contextValue = {
    mainOrgId,
    mainOrgUsername,
    setMainOrgHandler,
    clientOrgId,
    setClientOrgHandler,
    connectionKey,
    setConnKeyHandler,
    connectionKeyMode,
    setConnectionKeyModeHandler,
    integrationDevice,
    setIntegrationDeviceHandler,
    isMaintainer,
    onIsMaintainerHandler,
    isTrustee,
    setIsTrusteeHandler,
    isSuperUser,
    setIsSuperUserHandler,
    mainOrgCountry,
    setMainCountryHandler,
    isTransformer,
    setIsTransformerHandler,
    isIntegrator,
    setIsIntegratorHandler,
    isBuilder,
    setIsBuilderHandler,
    clientType,
    setClientTypeHandler,
    ISVCustomer,
    setISVCustomerHandler,
    AccCustomer,
    setAccCustomerHandler,
    customerRelation,
    setCustomerRelationHandler,
    integrationNotFinished,
    setIntegrationNotFinishedHandler,
    roles,
    getRoles,
    aboutOrgId,
    setAboutOrgIdHandler,
    sessionInfo,
    setSessionInfoHandler,
    isLoaded,
    setIsLoaded,
    isSessionChecked,
    setIsSessionChecked,
    isPublic,
    setIsPublic,
    defaultDevice,
    setDefaultDeviceHandler,
    defaultDeviceMode,
    setDefaultDeviceModeHandler,
    domain,
    setDomainHandler,
    modeREI,
    setModeREIHandler
    // mainOrgTransfId,
    // onMainOrgTransfIdHandler,
  };

  return (
    <OrgIdContext.Provider value={contextValue}>
      {children}
    </OrgIdContext.Provider>
  );
};

export default OrgIdContextProvider;
